import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import axios from "axios";
import { MRT_PaginationState } from "mantine-react-table";

export interface PaymentsListingResponse {
  data: PaymentsListing[];
  totalRowCount: number;
  totalPages: number;
}

export interface PaymentsListing {
  simplePaymentId?: string;
  totalAmount?: number;
  status?: string;
  buyAmount?: number;
  buyCurrency?: string;
  sellAmount?: number;
  sellCurrency?: string;
  currencyPair?: string;
  rate?: number;
  paymentFee?: number;
  vatValue?: number;
  vatBaseValue?: number;
  totalFee?: number;
  createdAt?: string;
  completedAt?: string;
  rejectedAt?: string;
  reference?: string;
  referenceId?: string;
  paymentReference?: string;
  fundingSource?: string;
  comment?: string;
  paymentChannel?: string;
  bankCharges?: number;
  purposeOfTransfer?: string;
  beneficiary?: Beneficiary;
  fundingReference?: string;
  simplePaymentPartnerAccountId?: string;
  fixedSide?: string;
  settlementId?: string;
  fundingCutoffTime?: string;
  fundingCountry?: string;
  failureReason?: string;
  additionalNotes?: string;
  senderUserId?: string;
}

interface Beneficiary {
  entityType?: string;
  firstName?: string;
  lastName?: string;
  nickname?: string;
  companyName?: string;
  address?: string;
  city?: string;
  country?: string;
  marketMakerRef?: string;
  createdAt?: string;
  type?: string;
  id?: string;
  addressInChineseCharacters?: string;
  suburb?: string;
  postcode?: string;
  cityInChineseCharacters?: string;
  region?: string;
  state?: string;
  stateOrProvince?: string;
  updatedAt?: string;
  identificationType?: string;
  identificationValue?: string;
  email?: string;
  mobileNumber?: string;
  relationship?: string;
  companyNameInChineseCharacters?: string;
  businessType?: string;
  bankAccount?: BankAccount;
}

interface BankAccount {
  currency?: string;
  bicSwift?: string;
  bankName?: string;
  country?: string;
  accountNumber?: string;
  bankAccountHolderName?: string;
  createdAt?: string;
  type?: string;
  bankCode?: string;
  bankNameInChineseCharacters?: string;
  branchName?: string;
  branchCode?: string;
  address?: string;
  city?: string;
  bankAccountHolderNameInChineseCharacters?: string;
  routingCode?: string;
  aba?: string;
  bsbCode?: string;
  clabe?: string;
  cnaps?: string;
  iban?: string;
  ifscCode?: string;
  institutionNo?: string;
  sortCode?: string;
}

interface GetPaymentsListingRequest {
  token: string;
  externalAccount: string;
  pagination: MRT_PaginationState;
  startDate?: string;
  endDate?: string;
}

const getPaymentsListing = async ({
  token,
  externalAccount,
  pagination,
  startDate,
  endDate,
}: GetPaymentsListingRequest): Promise<PaymentsListingResponse> => {
  try {
    const params: any = {
      // Add 1 to pageIndex to convert from 0-based to 1-based index
      externalAccount,
      page: `${pagination.pageIndex + 1}`,
      pageSize: `${pagination.pageSize}`,
    };

    if (startDate) {
      params.startDate = startDate;
    }

    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axios.get(
      `${getBaseUrl(Microservice.PAYMENT)}/payment/ledger/getPaymentsListing`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        params,
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);

    throw new Error(message);
  }
};

export default getPaymentsListing;
